module.exports = __webpack_public_path__ + "7def7e2874a5fd377d31d6c141680bfd.svg";